import React from 'react';

import { useEmailMessageQuery } from '@dashboard/generated/wp/platform';
import { AttachFileOutlined } from '@mui/icons-material';
import { Chip, Paper, Stack } from '@mui/material';

type Props = {
  waypointEventId: string;
};
export default function RenderAttachments({ waypointEventId }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id: waypointEventId } });
  const attachments = data?.EmailMessage.attachments ?? [];

  if (attachments.length === 0) {
    return null;
  }

  return (
    <Paper component={Stack} flexWrap="wrap" spacing={1} direction="row" sx={{ p: 2 }}>
      {attachments.map((attachment, i) => (
        <Chip key={i} size="small" icon={<AttachFileOutlined />} label={attachment.name} />
      ))}
    </Paper>
  );
}
